import Intro from "../../../../src/components/usb-switcher/intro";
import * as React from 'react';
export default {
  Intro,
  React
};